module.exports = __webpack_public_path__ + "static/media/spares3.795e0db2.jpg";